import { render, staticRenderFns } from "./CommitmentInfo.vue?vue&type=template&id=12d1755e&scoped=true&"
import script from "./CommitmentInfo.vue?vue&type=script&lang=js&"
export * from "./CommitmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommitmentInfo.vue?vue&type=style&index=0&id=12d1755e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1755e",
  null
  
)

export default component.exports